var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0.5C2.67188 0.5 0 3.19531 0 6.5C0 9.82812 2.67188 12.5 6 12.5C9.30469 12.5 12 9.82812 12 6.5C12 3.19531 9.30469 0.5 6 0.5ZM8.69531 5.46875L5.69531 8.46875C5.57812 8.60938 5.41406 8.65625 5.25 8.65625C5.0625 8.65625 4.89844 8.60938 4.78125 8.46875L3.28125 6.96875C3.02344 6.71094 3.02344 6.3125 3.28125 6.05469C3.53906 5.79688 3.9375 5.79688 4.19531 6.05469L5.25 7.08594L7.78125 4.55469C8.03906 4.29688 8.4375 4.29688 8.69531 4.55469C8.95312 4.8125 8.95312 5.21094 8.69531 5.46875Z",
    fill: "#38AF49"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelected);
export default __webpack_public_path__ + "static/media/selected.bc8a3f3bb0876f723fc7b170f9b09fe2.svg";
export { ForwardRef as ReactComponent };